<template>
  <div class="chapter-selection">
    <ul>

      <li v-for="(item) in unlockLinks" :key="item.id">
        <a :href="item.pathName" class="btn btn-outline-dark rounded-pill btn-block">
          <span v-text="item.desc"></span>
        </a>
      </li>

    </ul>
  </div>
</template>

<script>
import Cookie from '@/utilities/Cookie.js'

export default {
  name: 'chapter-select',
  props: {
    nowStage: {
      type: String,
      required: false,
      default: 'start',
    }
  },
  data() {
    return {
      chapterList: [
        {
          id: 'start',
          pathName: './',
          desc: '首頁',
        },
        {
          id: 'comic1',
          pathName: './開始遊戲',
          desc: '第一章 - 1',
        },
        {
          id: 'meeting',
          pathName: './初會面',
          desc: '第一章 - 2',
        },
        {
          id: 'time',
          pathName: './前往小逸堂',
          desc: '第一章 - 3',
        },
        {
          id: 'next',
          pathName: './2',
          desc: '第二章 - 1',
        },
        {
          id: 'lin',
          pathName: './前往公會堂',
          desc: '第二章 - 2',
        },
        {
          id: 'kon',
          pathName: './臺灣新文化',
          desc: '第三章 - 1',
        },
        {
          id: 'tale',
          pathName: './前往孔廟',
          desc: '第三章 - 2',
        },
        {
          id: 'four',
          pathName: './四',
          desc: '第四章 - 1',
        },
        {
          id: 'comic2',
          pathName: './前往元清觀',
          desc: '第四章 - 2',
        },
        {
          id: 'sky',
          pathName: './天井',
          desc: '第四章 - 3',
        },
        {
          id: 'comic3',
          pathName: './智能金錢',
          desc: '第五章 - 1',
        },
        {
          id: 'police',
          pathName: './時空警察',
          desc: '第五章 - 2',
        },
        {
          id: 'cage',
          pathName: './前往彰化警察署',
          desc: '第五章 - 3',
        },
        {
          id: 'reality',
          pathName: './現實',
          desc: '第六章 - 1',
        },
        {
          id: 'cloud',
          pathName: './前往開化寺',
          desc: '第六章 - 2',
        },
        {
          id: 'comic4',
          pathName: './廣佈',
          desc: '第七章 - 1',
        },
        {
          id: 'virtual',
          pathName: './林先生',
          desc: '第七章 - 2',
        },
        {
          id: 'chaser',
          pathName: './前往高賓閣',
          desc: '第七章 - 3',
        },
        {
          id: 'comic5',
          pathName: './警察追來了',
          desc: '第七章 - 4',
        },
        {
          id: 'comic6',
          pathName: './逃出高賓閣',
          desc: '第七章 - 5',
        },
        {
          id: 'fan',
          pathName: './扇子',
          desc: '第七章 - 6',
        },
        {
          id: 'crystal',
          pathName: './第五個',
          desc: '第八章 - 1',
        },
        {
          id: 'comic7',
          pathName: './使用神秘晶體',
          desc: '第八章 - 2',
        },
        {
          id: 'brave',
          pathName: './勇士當為義鬥爭',
          desc: '第八章 - 3',
        },
        {
          id: 'mace',
          pathName: './前往賴和紀念館',
          desc: '第八章 - 4',
        },
        {
          id: 'normal',
          pathName: './沒有實體名片',
          desc: '終章 - 1',
        },
        {
          id: 'yesmace',
          pathName: './有實體名片',
          desc: '第八章 - 5',
        },
        {
          id: 'trueend',
          pathName: './診療座椅',
          desc: '終章 - 2',
        },
      ],
      cookieId: '',
    };
  },
  created() {
    this.cookieId = Cookie.getCookie('saveId');
    if (this.cookieId === null || this.cookieId.length === 0) {
      this.cookieId = '';
    }
    if (this.getIdLevel(this.cookieId) < this.getIdLevel(this.nowStage)) {
      this.cookieId = this.nowStage;
      Cookie.setCookie('saveId', this.cookieId);
    }
  },
  computed: {
    unlockLinks() {
      const res = [];
      for (let i=0;i<this.chapterList.length;i++) {
        res.push(this.chapterList[i]);
        if (this.chapterList[i].id === this.cookieId) {
          return res;
        }
      }
      return [];
    }
  },
  methods: {
    getIdLevel(id) {
      for (let i=0;i<this.chapterList.length;i++) {
        if (this.chapterList[i].id === id) {
          return i;
        }
      }
      return -1;
    }
  }
}
</script>

<style scoped>


.chapter-selection{

}

.chapter-selection ul{
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.chapter-selection ul li{
  list-style: none;
  flex: 0 0 50%;
  padding: 0 .5rem;
}

.chapter-selection ul li:not(:last-child){
  margin-bottom: .5rem;
}

.chapter-selection ul li a{

}

.chapter-selection ul li a:hover{

}

.chapter-selection ul li a:focus{

}

@media (min-width: 768px){
  .chapter-selection ul li{
    flex: 0 0 100%;
  }
}

</style>
